import styled from '@emotion/styled';

export const RiskFactorsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(3)};
  padding: 0;
  margin: 0;

  li {
    display: block;
  }
`;

export const RiskFactorsListItem = styled.span`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`;

export const Divider = styled.div`
  align-self: stretch;
  border-left: ${({ theme }) => theme.borderLight};
`;
